module.exports = __webpack_public_path__ + "img/sumary_total_expense.21310318.svg";